import { TIMELINE } from './constant';
// this class use Highchart renderer to render a timeline below chart
// to see the Highchart renderer API see https://api.highcharts.com/class-reference/Highcharts.SVGRenderer
// also, some methods of Highchart renderer, create Highchart SVG_ELEMENT
// it's api can be found in https://api.highcharts.com/class-reference/Highcharts.SVGElement
class Timeline {
  constructor(renderer) {
    this.renderer = renderer;
    this._bounds = undefined;
    this._createdElements = [];
    this._selectedEventRect = null;
    this._selectedCategory = '';
  }
  get selectedEventRect() {
    if (!this._selectedEventRect) return null;
    return this._selectedEventRect;
  }
  _resetTimeline() {
    this._createdElements.forEach(rect => rect.destroy());
    this._createdElements = [];
    this._selectedEventRect = null;
  }
  _createEventRect(point) {
    const { left, top } = this._bounds;
    const pointX = point.plotX;
    const x = left + pointX - TIMELINE.EVENT_RECT.WIDTH / 2;
    const rect = this.renderer
      .rect(x, top, TIMELINE.EVENT_RECT.WIDTH, TIMELINE.EVENT_RECT.HEIGHT)
      .attr({
        'data-category': point.category,
        'fill': TIMELINE.EVENT_RECT.COLOR,
      })
      .add();
    return rect;
  }
  _makeEventRectInteractive(eventRect, callback) {
    eventRect.css({ cursor: 'pointer' });
    eventRect.element.addEventListener('mousedown', () =>
      this._handleEventRectSelect(eventRect, callback),
    );
  }
  _handleEventRectSelect(eventRect, callback) {
    this._resetEventRect(this._selectedEventRect);
    this._makeEventRectBigger(eventRect);
    this._selectedEventRect = eventRect;
    this._selectedCategory = eventRect.element.dataset['category'];
    callback(eventRect);
  }
  _resetEventRect(eventRect) {
    if (!eventRect) return;
    const currentWidth = eventRect.attr('width');
    const newWidth = TIMELINE.EVENT_RECT.WIDTH;

    const newX = eventRect.attr('x') - (newWidth - currentWidth) / 2;
    eventRect
      .attr('width', newWidth)
      .attr('x', newX)
      .attr('fill', TIMELINE.EVENT_RECT.COLOR);
  }
  _makeEventRectBigger(eventRect) {
    if (!eventRect) return;
    const currentWidth = eventRect.attr('width');
    const newWidth = currentWidth * TIMELINE.EVENT_RECT.SELECT_SCALE;

    const newX = eventRect.attr('x') - (newWidth - currentWidth) / 2;
    eventRect
      .attr('width', newWidth)
      .attr('x', newX)
      .attr('fill', TIMELINE.EVENT_RECT.SELECTED_COLOR);
  }

  _createBaseline() {
    const { left, right, top } = this._bounds;
    const width = right - left;
    return this.renderer
      .rect(left, top, width, TIMELINE.EVENT_RECT.HEIGHT)
      .attr('fill', TIMELINE.BASE_LINE_COLOR)
      .add();
  }
  _findSelectedEventRect(eventRects) {
    return eventRects.find(eventRect => {
      return (
        //https://sentry.cafebazaar.ir/sentry/loebat/issues/14249684/?query=is%3Aunresolved
        //unable to reproduce the bug. so put condition as temporary solution
        eventRect.element &&
        eventRect.element.dataset['category'] === this._selectedCategory
      );
    });
  }

  _restyleSelectedEventRect(eventRects) {
    const selectedEventRect = this._findSelectedEventRect(eventRects);
    this._selectedEventRect = selectedEventRect;
    this._makeEventRectBigger(selectedEventRect);
  }
  /**
   *
   * @param {Object} bounds - position of the bound box that timeline should be placed in
   * @param {number} bounds.top
   * @param {number} bounds.bottom
   * @param {number} bounds.right
   * @param {number} bounds.left
   * @param {Array} points - an Array of Highchart Points, see https://api.highcharts.com/class-reference/Highcharts.Point \
   * also, it contains plotX that is not documented
   * @callback onPointSelect - it's called when you click on an event rect
   */
  create(bounds, points, onPointSelect) {
    this._bounds = bounds;
    this._resetTimeline();
    const baseline = this._createBaseline();
    const eventRects = points.map(point => this._createEventRect(point));
    this._restyleSelectedEventRect(eventRects);
    eventRects.forEach(eventRect =>
      this._makeEventRectInteractive(eventRect, onPointSelect),
    );
    this._createdElements.push(...eventRects, baseline);
  }
}

export default Timeline;
